import CustomElement from '../core/custom.js';
import 'flickity/dist/flickity.min.css';
import Flickity from 'flickity';
import Emitter from '../core/emitter.js';

export default window.customElements.define('default-slider', class extends CustomElement {
    constructor() {
        super();

        this.events = {
            'click .js-prev': '_onPrev',
            'click .js-next': '_onNext'
        }

        this._resize = this.resize.bind(this)

        this.initialized = false
    }

    connectedCallback() {
        this.$slider = this.querySelector('.js-slider')

        if (!this.$slider) {
            return console.warn('DefaultSlider: This component must be have a .js-slider child', this)
        }

        this._props.freeScroll = this.dataset.freeScroll === "true" || false
        this._props.wrapAround = this.dataset.wrapAround === "true" || false
        this._props.equalHeight = this.dataset.equalHeight === "true" || false
        this._props.contain = this.dataset.contain === "true" || false
        this._props.cellAlign = this.dataset.cellAlign || "left"
        this._props.groupCells = Number(this.dataset.groupCells) || false

        super.connectedCallback();

        if (this.matchesBreakpoint) {
            this.init()
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        this.destroy()
    }

    onBreakpoint({matches}) {
        if (matches) {
            this.init()
        } else {
            this.destroy()
        }
    }

    init() {
        if (this.initialized) return
        
        this.initialized = true

        this._flkty = new Flickity(this.$slider, {
            draggable: true,
            resize: false,
            prevNextButtons: false,
            pageDots: false,
            friction: 0.3,
            freeScroll: this._props.freeScroll,
            wrapAround: this._props.wrapAround,
            contain: this._props.contain,
            cellAlign: this._props.cellAlign,
            groupCells: this._props.groupCells,
        });

        this._cellElements = this._flkty.getCellElements()

        this.$prev = this.querySelector('.js-prev')
        this.$next = this.querySelector('.js-next')

        // Enablad/Disabled prev and next button (if not wrapAround)
        if(!this._props.wrapAround) {
            if (this.$prev) {
                this.$prev.classList.add('is-disabled')
            }
    
            this._flkty.on( 'change', (index) => {
                if (!this.$prev || !this.$next) return
    
                this.$prev.classList[(index === 0) ? 'add' : 'remove']('is-disabled')
                this.$next.classList[(index === this._flkty.slides.length-1) ? 'add' : 'remove']('is-disabled')
            });
        }

        // Disabled click on link during drag
        this._flkty.on( 'dragMove', () => {
            this.$slider.style.pointerEvents = 'none'
        })

        this._flkty.on( 'dragEnd', () => {
            this.$slider.style.pointerEvents = null
        });

        // Synchronise resize
        Emitter.on('resize', this._resize)

        this.resize()
    }

    destroy() {
        if (!this.initialized) return

        this._flkty.destroy()
        this.initialized = false
        Emitter.off('resize', this._resize)
        
    }

    resize() {
        if (this._props.equalHeight && this._flkty) {
            this._flkty.slides.forEach((slide, i) => {
                this._cellElements[i].style.height = ''
            });
        
            let heights = this._flkty.slides.map((slide, i) => this._cellElements[i].offsetHeight),
                max = Math.max(heights);
            
            this._flkty.slides.forEach((slide, i) => this._cellElements[i].style.height = max + 'px');
        }

        this._flkty.resize()
    }

    _onPrev() {
        this._flkty.previous()
    }

    _onNext() {
        this._flkty.next()
    }
});